// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"109376c8","842":"109376c8"}[chunkId] + ".chunk.css";
};